<template>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex xs8 offset-xs2>
          <h1 class="display-1">New Color</h1>
          <v-select v-model="color.fabric" v-if="fabrics" :items="fabrics" item-value="_id" label="Fabric">
            <template slot="selection" slot-scope="data">
              {{ data.item.group.type }} - {{ data.item.name }}
            </template>
            <template slot="item" slot-scope="data">
              {{ data.item.group.type }} - {{ data.item.name }}
            </template>
          </v-select>
          <v-text-field label="Name" v-model="color.name"></v-text-field>
          <v-text-field label="TWC Name" v-model="color.twcName"></v-text-field>
          <v-text-field label="Small Image" v-model="color.smallImage"></v-text-field>
          <v-text-field label="Large Image" v-model="color.largeImage"></v-text-field>
          <v-checkbox label="Status" v-model="color.status" checked></v-checkbox>
          <v-btn color="primary" large @click="addColor()">Add Colour</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
</template>
<script>
import FabricService from '@/services/FabricService.js'
import ColorService from '@/services/ColorService.js'
export default {
  data () {
    return {
      fabrics: null,
      color: {
        name: null,
        twcName: null,
        fabric: null,
        smallImage: null,
        largeImage: null,
        status: null,
        tags: []
      }
    }
  },
  mounted () {
    this.getFabrics()
  },
  methods: {
    async getFabrics () {
      const response = await FabricService.getFabrics()
      this.fabrics = response.data.fabrics
      console.log(this.fabrics)
    },

    async addColor () {
      await ColorService.createColor(this.color)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/colours/NewColor.vue